import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareArrowDown"><Path d="M12 7.5V13.5M14.5 11.5L12 14L9.5 11.5M8.5 16.5H15.5M3.5 3.5H20.5V20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareArrowDown;
